import { Fragment, useEffect, useState } from "react";
import { ExamLabel } from "../../components/commons";
import { Link, useHistory } from "react-router-dom";
import * as SHARED from "../../utils/shared";
import { getConfig } from "../../api/sistema";
import { Button, Select, Form, Input, message } from "antd";
import { storeParticipanteAcount } from "../../api/participante";

const { Option } = Select;

// const tipoparticipaicion = [
//   { value: 1, name: "DOCENTE SUPERVISOR" },
//   { value: 2, name: "ESTUDIANTE OBSERVADOR" },
//   { value: 3, name: "ADMINISTRATIVO PARA INTERNAMIENTO" },
//   { value: 4, name: "DOCENTE ELABORADOR" }
// ];

function ParticipanteSolicitarContrasenia() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [config, setConfig] = useState({
    activoSolicitaContrasenia: false
  });

  const fetchConfig = async () => {
    try {
      setIsLoading(true);
      const res = await getConfig();
      setConfig(res.payload);
    } catch (err) {
      setConfig({
        activoSolicitaContrasenia: false
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  const onFinish = (values) => {
    const { email, idmodalidad } = values;
    const modalidad = SHARED.MODALIDADES.find((i) => i.value === idmodalidad);

    sendPassword({
      email,
      idtipoparticipante: modalidad.idtipoparticipante,
      idtipoparticipacion: modalidad.idtipoparticipacion
    });
  };

  const sendPassword = async (data) => {
    try {
      setIsSending(true);
      const response = await storeParticipanteAcount(data);
      if (response) {
        message.success(response.message);
        history.push("/");
      }
    } catch (err) {
      message.error(err.message);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Fragment>
      <div className="max-w-xs mx-auto mt-10">
        <ExamLabel
          firstTitle={"Registro de participante"}
          mainTitle={SHARED.PROCESO}
          style={{ background: "#D41D3D" }}
        />
      </div>

      {/* <p className="text-center mb-4 font-semibold text-base">
        Existen dos modalidades de participación:
      </p> */}

      {/* <div className="max-w-lg mx-auto w-full flex flex-col gap-2 text-center">
        <div className="w-full">
          <span className="text-gray-700 font-semibold text-base">1) Internamiento: </span>
          <span className="text-base">Participación en la elaboración del examen.</span>
        </div>
        <div className="w-full">
          <span className="text-gray-700 font-semibold text-base">2) Supervisión: </span>
          <span className="text-base">Participación durante la ejecución del examen.</span>
        </div>
      </div> */}

      <Form onFinish={onFinish} className="max-w-xs mx-auto text-center" layout="vertical">
        <div className="max-w-lg mx-auto w-full mt-4 text-center">
          {/* <span className="mb-2 text-base">Haga click en la opción que se adecue a su perfil:</span> */}

          <div className="w-full max-w-sm my-3 mx-auto ">
            <Form.Item
              name="email"
              label="Correo electrónico institucional"
              rules={[{ required: true, message: "El correo electrónico es necesario" }]}
            >
              <Input disabled={!config.activoSolicitaContrasenia} type="email" />
            </Form.Item>

            <Form.Item
              name="idmodalidad"
              label="Seleccione una modalidad"
              // initialValue={participante ? Number(participante) : null}
              rules={[{ required: true, message: "Este campo es requerido" }]}
            >
              <Select
                disabled={!config.activoSolicitaContrasenia}
                placeholder="Seleccione una opción"
                className="text-base"
              >
                {SHARED.MODALIDADES.map((item) => (
                  <Option key={item.value} value={item.value}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <div
              className={`bg-gray-100 border-t-4 mb-8 rounded-b text-teal-900 px-4 py-3 shadow-md`}
              role="alert"
            >
              <div className="text-center">
                <p className="text-sm">
                  RECUERDE QUE DEBE UTILIZAR SU CORREO INSTITUCIONAL PARA SOLICITAR LA CONTRASEÑA
                </p>
                <p>
                  <b>Ejemplo: jperezh@unjbg.edu.pe</b>
                </p>
              </div>
            </div>

            <Form.Item>
              {config.activoSolicitaContrasenia && (
                <Button
                  type="primary"
                  block
                  loading={isLoading || isSending}
                  disabled={!config.activoSolicitaContrasenia}
                  htmlType="submit"
                >
                  Enviar contraseña a mi correo
                </Button>
              )}
            </Form.Item>

            <Link to="/reenviar-contrasenia">
              <Button className="mb-2" type="link" block>
                Olvidé mi contraseña
              </Button>
            </Link>
            <Link to="/">
              <Button className="mb-6" type="link" block>
                Regresar a Iniciar sesión
              </Button>
            </Link>
          </div>
        </div>
      </Form>
    </Fragment>
  );
}

export default ParticipanteSolicitarContrasenia;
